import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';
import type { JobBoard, JobBoardPayloadParams } from '@recruitee/job-boards-types';

import { OfferJobBoardActions, OfferJobBoardSelectors } from './offer-job-board.store';

@Injectable({ providedIn: 'root' })
export class OfferJobBoardStoreService {
  private readonly store = inject(Store);

  public getOfferJobBoards(offerId: number): Observable<JobBoard[]> {
    return this.store
      .select(OfferJobBoardSelectors.entities({ scope: offerId.toString() }))
      .pipe(filterBoolean);
  }

  public getOfferJobBoardCounters(offerId: number): Observable<{ all: number; published: number }> {
    return this.store
      .select(OfferJobBoardSelectors.counters({ scope: offerId.toString() }))
      .pipe(filterBoolean);
  }

  public getOfferJobBoardsLoaded(offerId: number): Observable<boolean> {
    return this.store.select(OfferJobBoardSelectors.isLoaded({ scope: offerId.toString() }));
  }

  public fetchOfferJobBoards(offerId: number): void {
    this.store.dispatch(
      OfferJobBoardActions.fetchCollection({ payload: { scope: offerId.toString() } }),
    );
  }

  public fetchPaginatedOfferJobBoards(offerId: number, params?: JobBoardPayloadParams): void {
    this.store.dispatch(
      OfferJobBoardActions.fetchPaginated({
        payload: {
          scope: offerId.toString(),
          params,
        },
      }),
    );
  }

  public fetchOfferJobBoardsCounters(offerId: number): void {
    this.store.dispatch(OfferJobBoardActions.fetchCounters({ payload: { id: offerId } }));
  }
}
